import { createApp } from 'vue'
import QuadroM from 'quadro_m'
import MyI18n from './plugins/my_i18n'


class MediatorPanel {
  constructor(elementId, apiEndpoint, caseId, ...args) {
    let credentials
    let options
    if (args[0] && args[1]) {
      credentials = {username: args[0], apiKey: args[1]}
      options = args[3]
    } else {
      options = args[0]
    }
    if (options?.locale) {
      MyI18n.locale = options.locale
    }

    this.parent = createApp({
      el: elementId,
      data: {options},
      render: h => h(QuadroM, {props: {apiEndpoint, caseId, credentials}})
    })

    this.app = this.parent.$children[0]
    this.app.config.productionTip = false
    this.app.use(MyI18n)

  }
}

export default MediatorPanel
